import useCallAgentPermissions, {
  AgentCallPermissions,
} from './useCallAgentPermissions';

const useCallAgentPermissionFlags = () => {
  const { hasPermission } = useCallAgentPermissions();

  const isEnabled = hasPermission(AgentCallPermissions.CAN_START_ANSWER_CALL);
  const isVisible = hasPermission(AgentCallPermissions.CAN_RECEIVE_CALLS);

  return { isEnabled, isVisible };
};

export default useCallAgentPermissionFlags;
